module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_2_5.834ab567.png";